import "./ConnectSection.scss"
import { useTextStorage } from "../../../../hooks"
import { ConnectForm } from "./ConnectForm"

export const ConnectSection: React.FC = () => {
  const { ts } = useTextStorage()

  return (
    <div className="connect-section">
      <div className="image-container">
        <div className="texts-container">
          <h2>{ts.pages.home.connectSection.title}</h2>
          <p>{ts.pages.home.connectSection.text}</p>
        </div>

        <ConnectForm />
      </div>

      <div className="right-block"></div>
    </div>
  )
}
